// A booking's references as people copy them: two rooms' written as one ("3906-5167-1399 / 3906-5168-9376") are
// two. The card's At a glance shows each (web/src/CardSections.tsx), and tidy-up looks for each in the notes
// (src/store/tidy.ts, repeated_in_notes), so both split them alike.
export const refsOf = (ref: string): string[] =>
  ref
    .split(/\s+\/\s+|\s*[,;]\s*|\s+&\s+/)
    .map((r) => r.trim())
    .filter(Boolean);
